import { connect } from 'react-redux';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import {
  isCpOrderEnabled,
  isLimitOrderEnabled,
  isLiveQuoteEnabled,
  isRealtimeQuoteEnabled,
} from 'state/secondaryMarket/productSearch/productSearch.selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import {
  isSecondaryMarketCpOrderEnabledForUser,
  isSecondaryMarketLimitOrderEnabledForUser,
  isSecondaryMarketLiveQuoteEnabledForUser,
} from 'state/user';
import {
  secondaryCPOrderTabCreatedFromProductSearchThunk,
  secondaryRealtimeQuoteOpenedFromProductSearchThunk,
} from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';

type OwnProps = {
  rowId: string;
};

type StateProps = {
  isRealtimeQuoteEnabled: boolean;
  isCpOrderEntitled: boolean;
  isCpOrderEnabled: boolean;
  isLiveQuoteEntitled: boolean;
  isLiveQuoteEnabled: boolean;
  isLimitOrderEntitled: boolean;
  isLimitOrderEnabled: boolean;
};

type DispatchProps = {
  openQuote: (rowId: string) => void;
  openCPOrderTab: (rowId: string) => void;
  openLiveTab: (rowId: string) => void;
  openLimitOrderTab: (rowId: string) => void;
};

export type ButtonsPanelProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { rowId }: OwnProps): StateProps => {
  return {
    isRealtimeQuoteEnabled: isRealtimeQuoteEnabled(state, rowId),
    isCpOrderEntitled: isSecondaryMarketCpOrderEnabledForUser(state),
    isCpOrderEnabled: isCpOrderEnabled(state, rowId),
    isLiveQuoteEntitled: isSecondaryMarketLiveQuoteEnabledForUser(state),
    isLiveQuoteEnabled: isLiveQuoteEnabled(state, rowId),
    isLimitOrderEntitled: isSecondaryMarketLimitOrderEnabledForUser(state),
    isLimitOrderEnabled: isLimitOrderEnabled(state, rowId),
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  openQuote: rowId => {
    dispatch(secondaryRealtimeQuoteOpenedFromProductSearchThunk(rowId));
  },
  openCPOrderTab: rowId => {
    dispatch(secondaryCPOrderTabCreatedFromProductSearchThunk(rowId));
  },
  openLiveTab: rowId => {
    dispatch(liveThunks.tabCreatedThunk(rowId));
  },
  openLimitOrderTab: rowId => {
    dispatch(limitOrderThunks.tabCreatedThunk(rowId));
  },
});

export const connectButtonPanel = connect(mapStateToProps, mapDispatchToProps);
